/* tslint:disable */
/* eslint-disable */
/**
 * Hyper GES API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssistitoTerapiaUpdateDTO
 */
export interface AssistitoTerapiaUpdateDTO {
    /**
     * 
     * @type {string}
     * @memberof AssistitoTerapiaUpdateDTO
     */
    nome?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoTerapiaUpdateDTO
     */
    richiedente?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoTerapiaUpdateDTO
     */
    patologiaMotivante?: string;
    /**
     * 
     * @type {Date}
     * @memberof AssistitoTerapiaUpdateDTO
     */
    dataInizio?: Date;
    /**
     * 
     * @type {string}
     * @memberof AssistitoTerapiaUpdateDTO
     */
    tipologiaMedicinale?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoTerapiaUpdateDTO
     */
    posologia?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoTerapiaUpdateDTO
     */
    note?: string;
}

/**
 * Check if a given object implements the AssistitoTerapiaUpdateDTO interface.
 */
export function instanceOfAssistitoTerapiaUpdateDTO(value: object): value is AssistitoTerapiaUpdateDTO {
    return true;
}

export function AssistitoTerapiaUpdateDTOFromJSON(json: any): AssistitoTerapiaUpdateDTO {
    return AssistitoTerapiaUpdateDTOFromJSONTyped(json, false);
}

export function AssistitoTerapiaUpdateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssistitoTerapiaUpdateDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'nome': json['nome'] == null ? undefined : json['nome'],
        'richiedente': json['richiedente'] == null ? undefined : json['richiedente'],
        'patologiaMotivante': json['patologiaMotivante'] == null ? undefined : json['patologiaMotivante'],
        'dataInizio': json['dataInizio'] == null ? undefined : (new Date(json['dataInizio'])),
        'tipologiaMedicinale': json['tipologiaMedicinale'] == null ? undefined : json['tipologiaMedicinale'],
        'posologia': json['posologia'] == null ? undefined : json['posologia'],
        'note': json['note'] == null ? undefined : json['note'],
    };
}

export function AssistitoTerapiaUpdateDTOToJSON(value?: AssistitoTerapiaUpdateDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'nome': value['nome'],
        'richiedente': value['richiedente'],
        'patologiaMotivante': value['patologiaMotivante'],
        'dataInizio': value['dataInizio'] == null ? undefined : ((value['dataInizio'] as any).toISOString()),
        'tipologiaMedicinale': value['tipologiaMedicinale'],
        'posologia': value['posologia'],
        'note': value['note'],
    };
}

